import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#0052B4\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#FFDA44\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#0052B4\" d=\"M12.001 0C5.725 0 .576 4.817.047 10.956h23.909C23.426 4.817 18.277 0 12 0M12.001 24c6.276 0 11.426-4.818 11.955-10.956H.046C.577 19.182 5.727 24 12.002 24\"></path><path fill=\"#F0F0F0\" d=\"m9.914 16.175-1.345.632.716 1.302-1.46-.279-.185 1.475-1.017-1.085-1.017 1.085-.185-1.475-1.46.28.716-1.303-1.345-.632 1.345-.633-.716-1.302 1.46.28.185-1.476 1.017 1.085 1.017-1.085.185 1.475 1.46-.28-.716 1.303z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }